import { getCloudMigrationInfo } from '@atlassian/mpac-api-client';
import { hooks, log } from '@atlassian/mpac-utils';

import type { CloudMigration } from '@atlassian/mpac-api-client';
import type { AppListingCloudMigration } from '@atlassian/mpac-types';

const useCloudMigrationInfo = (mpacBaseUrl: string, appKey: string): AppListingCloudMigration => {
  // @ts-expect-error [MC-2850] - TS2322 - Type 'State<CloudMigration | null | undefined>' is not assignable to type '{ result: CloudMigration | null | undefined; error: any; }'.
  const {
    result = null,
    error = null,
  }: {
    result: CloudMigration | null | undefined;
    error: any | null | undefined;
  } = hooks.usePromise(() => getCloudMigrationInfo(mpacBaseUrl, appKey));

  if (error) {
    log.error(
      'Cloud migration status check',
      `Failed to retrieve cloud migration status for ${appKey}`,
      error
    );
  }

  return {
    appKey,
    alternateCloudAppKey: appKey === result?.cloudAddonKey ? null : result?.cloudAddonKey,
    featureDifferenceDocumentation: result?.featureDifferenceDocumentation,
    migrationDocumentation: result?.migrationDocumentation,
  };
};

export default useCloudMigrationInfo;
